/**
 * Models generated from "Model and Storage" and models extracted from services.
 * To generate entity use syntax:
 * Apperyio.EntityAPI("<model_name>[.<model_field>]");
 */
export var models = {
    "String": {
        "type": "string"
    },
    "Boolean": {
        "type": "boolean"
    },
    "get_town_list_service_Model": {
        "type": "object",
        "properties": {
            "_id": {
                "type": "string"
            },
            "_createdAt": {
                "type": "string"
            },
            "_updatedAt": {
                "type": "string"
            },
            "town": {
                "type": "string"
            }
        }
    },
    "SlidesModel": {
        "type": "array",
        "items": [{
            "type": "SlideModel"
        }]
    },
    "Number": {
        "type": "number"
    },
    "NOAA_clone": {
        "type": "object",
        "properties": {
            "predictions": {
                "type": "array",
                "items": [{
                    "type": "object",
                    "properties": {
                        "v": {
                            "type": "number"
                        },
                        "t": {
                            "type": "string"
                        },
                        "type": {
                            "type": "string"
                        }
                    }
                }]
            }
        }
    },
    "BEACH": {
        "type": "object",
        "properties": {
            "predictions": {
                "type": "array",
                "items": [{
                    "type": "object",
                    "properties": {
                        "name": {
                            "type": "string"
                        },
                        "parking_spaces_available": {
                            "type": "number"
                        },
                        "parking_spaces_total": {
                            "type": "number"
                        },
                        "percent_full": {
                            "type": "string"
                        }
                    }
                }]
            }
        }
    },
    "NOAA": {
        "type": "object",
        "properties": {
            "predictions": {
                "type": "array",
                "items": [{
                    "type": "object",
                    "properties": {
                        "t": {
                            "type": "string"
                        },
                        "v": {
                            "type": "number"
                        },
                        "type": {
                            "type": "string"
                        }
                    }
                }]
            }
        }
    },
    "data": {
        "type": "object",
        "properties": {
            "name": {
                "type": "string"
            },
            "_id": {
                "type": "string"
            },
            "showers": {
                "type": "string"
            },
            "bathrooms": {
                "type": "string"
            },
            "_updatedAt": {
                "type": "string"
            },
            "closing_time": {
                "type": "string"
            },
            "latitude": {
                "type": "string"
            },
            "ORV": {
                "type": "string"
            },
            "life_guards": {
                "type": "string"
            },
            "picnic": {
                "type": "string"
            },
            "saltwater": {
                "type": "string"
            },
            "food": {
                "type": "string"
            },
            "town": {
                "type": "string"
            },
            "boat_ramp": {
                "type": "string"
            },
            "open_time": {
                "type": "string"
            },
            "longitude": {
                "type": "string"
            }
        }
    },
    "SlideModel": {
        "type": "object",
        "properties": {
            "text": {
                "type": "string"
            },
            "title": {
                "type": "string"
            },
            "img": {
                "type": "string"
            }
        }
    },
    "Any": {
        "type": "any"
    },
    "what_beach_list_service_Model": {
        "type": "object",
        "properties": {
            "latitude": {
                "type": "string"
            },
            "_updatedAt": {
                "type": "string"
            },
            "longitude": {
                "type": "string"
            },
            "closing_time": {
                "type": "string"
            },
            "showers": {
                "type": "string"
            },
            "food": {
                "type": "string"
            },
            "open_time": {
                "type": "string"
            },
            "town": {
                "type": "string"
            },
            "boat_ramp": {
                "type": "string"
            },
            "_id": {
                "type": "string"
            },
            "picnic": {
                "type": "string"
            },
            "bathrooms": {
                "type": "string"
            },
            "ORV": {
                "type": "string"
            },
            "name": {
                "type": "string"
            },
            "saltwater": {
                "type": "string"
            },
            "life_guards": {
                "type": "string"
            }
        }
    },
    "Function": {
        "type": "Function"
    },
    "Promise": {
        "type": "Promise"
    },
    "Observable": {
        "type": "Observable"
    },
    "TEST_NOAA_TIDES": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/proxy/tunnel"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "datum": {
                                "type": "string",
                                "default": "MLLW"
                            },
                            "format": {
                                "type": "string",
                                "default": "json"
                            },
                            "begin_date": {
                                "type": "string",
                                "default": "20240701"
                            },
                            "end_date": {
                                "type": "string",
                                "default": "20240704"
                            },
                            "station": {
                                "type": "string",
                                "default": "8447525"
                            },
                            "time_zone": {
                                "type": "string",
                                "default": "lst_ldt"
                            },
                            "units": {
                                "type": "string",
                                "default": "english"
                            },
                            "product": {
                                "type": "string",
                                "default": "predictions"
                            },
                            "interval": {
                                "type": "string",
                                "default": "hilo"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "appery-transformation": {
                                "type": "string",
                                "default": "checkTunnel"
                            },
                            "appery-rest": {
                                "type": "string",
                                "default": "4fdbbfb0-3579-49fb-87ac-165b669e7be1"
                            },
                            "appery-proxy-url": {
                                "type": "string",
                                "default": "https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "predictions": {
                                        "type": "array",
                                        "items": [{
                                            "type": "object",
                                            "properties": {
                                                "type": {
                                                    "type": "string",
                                                    "default": "H"
                                                },
                                                "t": {
                                                    "type": "string",
                                                    "default": "2023-06-28 19:48"
                                                },
                                                "v": {
                                                    "type": "string",
                                                    "default": "9.505"
                                                }
                                            }
                                        }]
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "get_all_beach_parking_data": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/proxy/tunnel"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "town": {
                                "type": "string",
                                "default": "Eastham"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "appery-transformation": {
                                "type": "string",
                                "default": "checkTunnel"
                            },
                            "appery-rest": {
                                "type": "string",
                                "default": "4fdbbfb0-3579-49fb-87ac-165b669e7be1"
                            },
                            "appery-proxy-url": {
                                "type": "string",
                                "default": "https://api.appery.io/rest/1/code/e758142e-74e7-435c-8dae-4542438ff0e5/exec"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "predictions": {
                                        "type": "array",
                                        "items": [{
                                            "type": "object",
                                            "properties": {
                                                "name": {
                                                    "type": "string",
                                                    "default": "Kingsbury"
                                                },
                                                "parking_spaces_total": {
                                                    "type": "number",
                                                    "default": 1
                                                },
                                                "percent_full": {
                                                    "type": "string",
                                                    "default": "FULL"
                                                },
                                                "parking_spaces_available": {
                                                    "type": "number",
                                                    "default": 0
                                                }
                                            }
                                        }]
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "Get_beach_details_backup": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/code/6318964c-e9a4-4a26-bc92-d99f14c13a25/exec"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "what_beach": {
                                "type": "string",
                                "default": "Coast Guard"
                            },
                            "this_town": {
                                "type": "string",
                                "default": "Eastham"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "life_guards": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "ORV": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "boat_ramp": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "parking_spaces_available": {
                                            "type": "number",
                                            "default": 100
                                        },
                                        "food": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "_updatedAt": {
                                            "type": "string",
                                            "default": "2024-06-09T04:00:00.437Z"
                                        },
                                        "name": {
                                            "type": "string",
                                            "default": "Cooks Brook"
                                        },
                                        "Handicap_Parking_Spaces_Available": {
                                            "type": "number",
                                            "default": 1
                                        },
                                        "Handicap_Parking_Spaces_Total": {
                                            "type": "number",
                                            "default": 3
                                        },
                                        "town": {
                                            "type": "string",
                                            "default": "Eastham"
                                        },
                                        "saltwater": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "bathrooms": {
                                            "type": "string",
                                            "default": "PP"
                                        },
                                        "station": {
                                            "type": "string",
                                            "default": "8446613"
                                        },
                                        "showers": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "picnic": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "_id": {
                                            "type": "string",
                                            "default": "63f621fa2e22d756a720d908"
                                        },
                                        "parking_spaces_total": {
                                            "type": "number",
                                            "default": 100
                                        },
                                        "latitude": {
                                            "type": "string",
                                            "default": "41.864272"
                                        },
                                        "longitude": {
                                            "type": "string",
                                            "default": "-70.0078"
                                        },
                                        "sponsor_2": {
                                            "type": "object",
                                            "properties": {
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/9a02673f-66ee-4a8b-afc6-096eaa2343cd.Arnolds_LOGO_lo_rez.jpg"
                                                },
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "Arnolds_LOGO_lo_rez.jpg"
                                                },
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "9a02673f-66ee-4a8b-afc6-096eaa2343cd.Arnolds_LOGO_lo_rez.jpg"
                                                }
                                            }
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "get_town_list_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/code/3c6408fc-a7f1-4640-830e-711cd2aa07cd/exec"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "id": {
                                            "type": "string",
                                            "default": "66a6489a1438cd01cbb57b05"
                                        },
                                        "name": {
                                            "type": "string",
                                            "default": "TestTown"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "getWeather_Tides": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/proxy/tunnel"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "q": {
                                "type": "string",
                                "default": "41.871734,-70.008101"
                            },
                            "key": {
                                "type": "string",
                                "default": "f23430107f374319ab901208211701"
                            },
                            "fx": {
                                "type": "string",
                                "default": "yes"
                            },
                            "tide": {
                                "type": "string",
                                "default": "yes"
                            },
                            "format": {
                                "type": "string",
                                "default": "json"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "appery-transformation": {
                                "type": "string",
                                "default": "checkTunnel"
                            },
                            "appery-rest": {
                                "type": "string",
                                "default": "4fdbbfb0-3579-49fb-87ac-165b669e7be1"
                            },
                            "appery-proxy-url": {
                                "type": "string",
                                "default": "http://api.worldweatheronline.com/premium/v1/marine.ashx"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "data": {
                                        "type": "object",
                                        "properties": {
                                            "request": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "type": {
                                                            "type": "string",
                                                            "default": "LatLon"
                                                        },
                                                        "query": {
                                                            "type": "string",
                                                            "default": "Lat 41.87 and Lon -70.01"
                                                        }
                                                    }
                                                }]
                                            },
                                            "weather": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "mintempF": {
                                                            "type": "string",
                                                            "default": "37"
                                                        },
                                                        "maxtempF": {
                                                            "type": "string",
                                                            "default": "47"
                                                        },
                                                        "date": {
                                                            "type": "string",
                                                            "default": "2023-04-02"
                                                        },
                                                        "tides": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "tide_data": {
                                                                        "type": "array",
                                                                        "items": [{
                                                                            "type": "object",
                                                                            "properties": {
                                                                                "tide_type": {
                                                                                    "type": "string",
                                                                                    "default": "HIGH"
                                                                                },
                                                                                "tideHeight_mt": {
                                                                                    "type": "string",
                                                                                    "default": "2.80"
                                                                                },
                                                                                "tideDateTime": {
                                                                                    "type": "string",
                                                                                    "default": "2023-04-02 22:28"
                                                                                },
                                                                                "tideTime": {
                                                                                    "type": "string",
                                                                                    "default": "10:28 PM"
                                                                                }
                                                                            }
                                                                        }]
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "uvIndex": {
                                                            "type": "string",
                                                            "default": "2"
                                                        },
                                                        "mintempC": {
                                                            "type": "string",
                                                            "default": "3"
                                                        },
                                                        "astronomy": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "moonrise": {
                                                                        "type": "string",
                                                                        "default": "03:37 PM"
                                                                    },
                                                                    "sunrise": {
                                                                        "type": "string",
                                                                        "default": "06:21 AM"
                                                                    },
                                                                    "moonset": {
                                                                        "type": "string",
                                                                        "default": "05:10 AM"
                                                                    },
                                                                    "moon_phase": {
                                                                        "type": "string",
                                                                        "default": "Waxing Gibbous"
                                                                    },
                                                                    "sunset": {
                                                                        "type": "string",
                                                                        "default": "07:07 PM"
                                                                    },
                                                                    "moon_illumination": {
                                                                        "type": "string",
                                                                        "default": "82"
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "maxtempC": {
                                                            "type": "string",
                                                            "default": "8"
                                                        },
                                                        "hourly": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "visibility": {
                                                                        "type": "string",
                                                                        "default": "10"
                                                                    },
                                                                    "HeatIndexF": {
                                                                        "type": "string",
                                                                        "default": "37"
                                                                    },
                                                                    "winddirDegree": {
                                                                        "type": "string",
                                                                        "default": "328"
                                                                    },
                                                                    "WindGustKmph": {
                                                                        "type": "string",
                                                                        "default": "51"
                                                                    },
                                                                    "humidity": {
                                                                        "type": "string",
                                                                        "default": "57"
                                                                    },
                                                                    "swellHeight_m": {
                                                                        "type": "string",
                                                                        "default": "1.7"
                                                                    },
                                                                    "pressure": {
                                                                        "type": "string",
                                                                        "default": "1020"
                                                                    },
                                                                    "precipMM": {
                                                                        "type": "string",
                                                                        "default": "0.0"
                                                                    },
                                                                    "HeatIndexC": {
                                                                        "type": "string",
                                                                        "default": "3"
                                                                    },
                                                                    "FeelsLikeF": {
                                                                        "type": "string",
                                                                        "default": "29"
                                                                    },
                                                                    "swellDir16Point": {
                                                                        "type": "string",
                                                                        "default": "S"
                                                                    },
                                                                    "swellDir": {
                                                                        "type": "string",
                                                                        "default": "180"
                                                                    },
                                                                    "cloudcover": {
                                                                        "type": "string",
                                                                        "default": "6"
                                                                    },
                                                                    "windspeedKmph": {
                                                                        "type": "string",
                                                                        "default": "30"
                                                                    },
                                                                    "winddir16Point": {
                                                                        "type": "string",
                                                                        "default": "NNW"
                                                                    },
                                                                    "DewPointF": {
                                                                        "type": "string",
                                                                        "default": "24"
                                                                    },
                                                                    "swellHeight_ft": {
                                                                        "type": "string",
                                                                        "default": "5.6"
                                                                    },
                                                                    "weatherDesc": {
                                                                        "type": "array",
                                                                        "items": [{
                                                                            "type": "object",
                                                                            "properties": {
                                                                                "value": {
                                                                                    "type": "string",
                                                                                    "default": "Partly cloudy"
                                                                                }
                                                                            }
                                                                        }]
                                                                    },
                                                                    "WindChillF": {
                                                                        "type": "string",
                                                                        "default": "29"
                                                                    },
                                                                    "tempC": {
                                                                        "type": "string",
                                                                        "default": "3"
                                                                    },
                                                                    "weatherCode": {
                                                                        "type": "string",
                                                                        "default": "116"
                                                                    },
                                                                    "pressureInches": {
                                                                        "type": "string",
                                                                        "default": "30"
                                                                    },
                                                                    "waterTemp_F": {
                                                                        "type": "string",
                                                                        "default": "39"
                                                                    },
                                                                    "uvIndex": {
                                                                        "type": "string",
                                                                        "default": "1"
                                                                    },
                                                                    "waterTemp_C": {
                                                                        "type": "string",
                                                                        "default": "4"
                                                                    },
                                                                    "swellPeriod_secs": {
                                                                        "type": "string",
                                                                        "default": "11.8"
                                                                    },
                                                                    "DewPointC": {
                                                                        "type": "string",
                                                                        "default": "-5"
                                                                    },
                                                                    "precipInches": {
                                                                        "type": "string",
                                                                        "default": "0.0"
                                                                    },
                                                                    "windspeedMiles": {
                                                                        "type": "string",
                                                                        "default": "18"
                                                                    },
                                                                    "WindGustMiles": {
                                                                        "type": "string",
                                                                        "default": "32"
                                                                    },
                                                                    "FeelsLikeC": {
                                                                        "type": "string",
                                                                        "default": "-2"
                                                                    },
                                                                    "sigHeight_m": {
                                                                        "type": "string",
                                                                        "default": "0.8"
                                                                    },
                                                                    "weatherIconUrl": {
                                                                        "type": "array",
                                                                        "items": [{
                                                                            "type": "object",
                                                                            "properties": {
                                                                                "value": {
                                                                                    "type": "string",
                                                                                    "default": "https://cdn.worldweatheronline.com/images/wsymbols01_png_64/wsymbol_0004_black_low_cloud.png"
                                                                                }
                                                                            }
                                                                        }]
                                                                    },
                                                                    "time": {
                                                                        "type": "string",
                                                                        "default": "2100"
                                                                    },
                                                                    "tempF": {
                                                                        "type": "string",
                                                                        "default": "37"
                                                                    },
                                                                    "visibilityMiles": {
                                                                        "type": "string",
                                                                        "default": "6"
                                                                    },
                                                                    "WindChillC": {
                                                                        "type": "string",
                                                                        "default": "-2"
                                                                    }
                                                                }
                                                            }]
                                                        }
                                                    }
                                                }]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "getWeather_Only": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/proxy/tunnel"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "key": {
                                "type": "string",
                                "default": "f23430107f374319ab901208211701"
                            },
                            "q": {
                                "type": "string",
                                "default": "41.8434932, -69.9570108"
                            },
                            "format": {
                                "type": "string",
                                "default": "json"
                            },
                            "fx": {
                                "type": "string",
                                "default": "yes"
                            },
                            "cc": {
                                "type": "string",
                                "default": "yes"
                            },
                            "date": {
                                "type": "string",
                                "default": "TODAY"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "appery-transformation": {
                                "type": "string",
                                "default": "checkTunnel"
                            },
                            "appery-rest": {
                                "type": "string",
                                "default": "4fdbbfb0-3579-49fb-87ac-165b669e7be1"
                            },
                            "appery-proxy-url": {
                                "type": "string",
                                "default": "https://api.worldweatheronline.com/premium/v1/weather.ashx"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "data": {
                                        "type": "object",
                                        "properties": {
                                            "weather": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "hourly": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "weatherDesc": {
                                                                        "type": "array",
                                                                        "items": [{
                                                                            "type": "object",
                                                                            "properties": {
                                                                                "value": {
                                                                                    "type": "string",
                                                                                    "default": "Clear"
                                                                                }
                                                                            }
                                                                        }]
                                                                    },
                                                                    "chanceofwindy": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "winddir16Point": {
                                                                        "type": "string",
                                                                        "default": "NNW"
                                                                    },
                                                                    "tempC": {
                                                                        "type": "string",
                                                                        "default": "4"
                                                                    },
                                                                    "FeelsLikeF": {
                                                                        "type": "string",
                                                                        "default": "29"
                                                                    },
                                                                    "time": {
                                                                        "type": "string",
                                                                        "default": "2100"
                                                                    },
                                                                    "chanceofthunder": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "uvIndex": {
                                                                        "type": "string",
                                                                        "default": "1"
                                                                    },
                                                                    "visibilityMiles": {
                                                                        "type": "string",
                                                                        "default": "6"
                                                                    },
                                                                    "windspeedKmph": {
                                                                        "type": "string",
                                                                        "default": "33"
                                                                    },
                                                                    "tempF": {
                                                                        "type": "string",
                                                                        "default": "39"
                                                                    },
                                                                    "WindGustMiles": {
                                                                        "type": "string",
                                                                        "default": "28"
                                                                    },
                                                                    "chanceofremdry": {
                                                                        "type": "string",
                                                                        "default": "92"
                                                                    },
                                                                    "chanceofhightemp": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "DewPointC": {
                                                                        "type": "string",
                                                                        "default": "-7"
                                                                    },
                                                                    "chanceoffog": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "WindChillF": {
                                                                        "type": "string",
                                                                        "default": "29"
                                                                    },
                                                                    "cloudcover": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "precipMM": {
                                                                        "type": "string",
                                                                        "default": "0.0"
                                                                    },
                                                                    "WindGustKmph": {
                                                                        "type": "string",
                                                                        "default": "44"
                                                                    },
                                                                    "FeelsLikeC": {
                                                                        "type": "string",
                                                                        "default": "-2"
                                                                    },
                                                                    "HeatIndexC": {
                                                                        "type": "string",
                                                                        "default": "4"
                                                                    },
                                                                    "winddirDegree": {
                                                                        "type": "string",
                                                                        "default": "330"
                                                                    },
                                                                    "chanceoffrost": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "precipInches": {
                                                                        "type": "string",
                                                                        "default": "0.0"
                                                                    },
                                                                    "humidity": {
                                                                        "type": "string",
                                                                        "default": "44"
                                                                    },
                                                                    "windspeedMiles": {
                                                                        "type": "string",
                                                                        "default": "21"
                                                                    },
                                                                    "pressure": {
                                                                        "type": "string",
                                                                        "default": "1017"
                                                                    },
                                                                    "WindChillC": {
                                                                        "type": "string",
                                                                        "default": "-2"
                                                                    },
                                                                    "pressureInches": {
                                                                        "type": "string",
                                                                        "default": "30"
                                                                    },
                                                                    "weatherIconUrl": {
                                                                        "type": "array",
                                                                        "items": [{
                                                                            "type": "object",
                                                                            "properties": {
                                                                                "value": {
                                                                                    "type": "string",
                                                                                    "default": "https://cdn.worldweatheronline.com/images/wsymbols01_png_64/wsymbol_0008_clear_sky_night.png"
                                                                                }
                                                                            }
                                                                        }]
                                                                    },
                                                                    "chanceofovercast": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "chanceofsunshine": {
                                                                        "type": "string",
                                                                        "default": "88"
                                                                    },
                                                                    "DewPointF": {
                                                                        "type": "string",
                                                                        "default": "19"
                                                                    },
                                                                    "visibility": {
                                                                        "type": "string",
                                                                        "default": "10"
                                                                    },
                                                                    "chanceofrain": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    },
                                                                    "HeatIndexF": {
                                                                        "type": "string",
                                                                        "default": "39"
                                                                    },
                                                                    "weatherCode": {
                                                                        "type": "string",
                                                                        "default": "113"
                                                                    },
                                                                    "chanceofsnow": {
                                                                        "type": "string",
                                                                        "default": "0"
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "avgtempC": {
                                                            "type": "string",
                                                            "default": "5"
                                                        },
                                                        "maxtempC": {
                                                            "type": "string",
                                                            "default": "5"
                                                        },
                                                        "totalSnow_cm": {
                                                            "type": "string",
                                                            "default": "0.0"
                                                        },
                                                        "maxtempF": {
                                                            "type": "string",
                                                            "default": "42"
                                                        },
                                                        "mintempF": {
                                                            "type": "string",
                                                            "default": "36"
                                                        },
                                                        "uvIndex": {
                                                            "type": "string",
                                                            "default": "1"
                                                        },
                                                        "sunHour": {
                                                            "type": "string",
                                                            "default": "12.8"
                                                        },
                                                        "date": {
                                                            "type": "string",
                                                            "default": "2023-04-02"
                                                        },
                                                        "astronomy": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "moon_illumination": {
                                                                        "type": "string",
                                                                        "default": "84"
                                                                    },
                                                                    "moon_phase": {
                                                                        "type": "string",
                                                                        "default": "Waxing Gibbous"
                                                                    },
                                                                    "sunset": {
                                                                        "type": "string",
                                                                        "default": "07:08 PM"
                                                                    },
                                                                    "sunrise": {
                                                                        "type": "string",
                                                                        "default": "06:22 AM"
                                                                    },
                                                                    "moonrise": {
                                                                        "type": "string",
                                                                        "default": "03:38 PM"
                                                                    },
                                                                    "moonset": {
                                                                        "type": "string",
                                                                        "default": "05:11 AM"
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "mintempC": {
                                                            "type": "string",
                                                            "default": "2"
                                                        },
                                                        "avgtempF": {
                                                            "type": "string",
                                                            "default": "41"
                                                        }
                                                    }
                                                }]
                                            },
                                            "request": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "query": {
                                                            "type": "string",
                                                            "default": "Lat 41.87 and Lon -70.01"
                                                        },
                                                        "type": {
                                                            "type": "string",
                                                            "default": "LatLon"
                                                        }
                                                    }
                                                }]
                                            },
                                            "current_condition": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "uvIndex": {
                                                            "type": "string",
                                                            "default": "2"
                                                        },
                                                        "temp_C": {
                                                            "type": "string",
                                                            "default": "7"
                                                        },
                                                        "winddirDegree": {
                                                            "type": "string",
                                                            "default": "330"
                                                        },
                                                        "visibilityMiles": {
                                                            "type": "string",
                                                            "default": "9"
                                                        },
                                                        "precipMM": {
                                                            "type": "string",
                                                            "default": "0.0"
                                                        },
                                                        "windspeedMiles": {
                                                            "type": "string",
                                                            "default": "12"
                                                        },
                                                        "visibility": {
                                                            "type": "string",
                                                            "default": "16"
                                                        },
                                                        "windspeedKmph": {
                                                            "type": "string",
                                                            "default": "19"
                                                        },
                                                        "winddir16Point": {
                                                            "type": "string",
                                                            "default": "NNW"
                                                        },
                                                        "weatherCode": {
                                                            "type": "string",
                                                            "default": "113"
                                                        },
                                                        "weatherDesc": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "value": {
                                                                        "type": "string",
                                                                        "default": "Sunny"
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "humidity": {
                                                            "type": "string",
                                                            "default": "58"
                                                        },
                                                        "weatherIconUrl": {
                                                            "type": "array",
                                                            "items": [{
                                                                "type": "object",
                                                                "properties": {
                                                                    "value": {
                                                                        "type": "string",
                                                                        "default": "https://cdn.worldweatheronline.com/images/wsymbols01_png_64/wsymbol_0001_sunny.png"
                                                                    }
                                                                }
                                                            }]
                                                        },
                                                        "pressureInches": {
                                                            "type": "string",
                                                            "default": "30"
                                                        },
                                                        "FeelsLikeC": {
                                                            "type": "string",
                                                            "default": "2"
                                                        },
                                                        "precipInches": {
                                                            "type": "string",
                                                            "default": "0.0"
                                                        },
                                                        "pressure": {
                                                            "type": "string",
                                                            "default": "1006"
                                                        },
                                                        "temp_F": {
                                                            "type": "string",
                                                            "default": "45"
                                                        },
                                                        "cloudcover": {
                                                            "type": "string",
                                                            "default": "0"
                                                        },
                                                        "observation_time": {
                                                            "type": "string",
                                                            "default": "02:45 PM"
                                                        },
                                                        "FeelsLikeF": {
                                                            "type": "string",
                                                            "default": "35"
                                                        }
                                                    }
                                                }]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "Get_beach_detaIls": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/code/6318964c-e9a4-4a26-bc92-d99f14c13a25/exec"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "what_beach": {
                                "type": "string",
                                "default": "Coast Guard"
                            },
                            "this_town": {
                                "type": "string",
                                "default": "Eastham"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "_id": {
                                            "type": "string",
                                            "default": "63f621fa2e22d756a720d908"
                                        },
                                        "Handicap_Parking_Spaces_Total": {
                                            "type": "number",
                                            "default": 3
                                        },
                                        "_updatedAt": {
                                            "type": "string",
                                            "default": "2024-07-06T17:58:15.482Z"
                                        },
                                        "latitude": {
                                            "type": "string",
                                            "default": "41.864272"
                                        },
                                        "life_guards": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "percent_full": {
                                            "type": "number",
                                            "default": 0
                                        },
                                        "alcohol_okay": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "sponsor_2": {
                                            "type": "object",
                                            "properties": {
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/9a02673f-66ee-4a8b-afc6-096eaa2343cd.Arnolds_LOGO_lo_rez.jpg"
                                                },
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "9a02673f-66ee-4a8b-afc6-096eaa2343cd.Arnolds_LOGO_lo_rez.jpg"
                                                },
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "Arnolds_LOGO_lo_rez.jpg"
                                                }
                                            }
                                        },
                                        "open_time": {
                                            "type": "string",
                                            "default": "9"
                                        },
                                        "public": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "beach_image1": {
                                            "type": "object",
                                            "properties": {
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/2c61d16b-4fac-43c6-8bcd-7711411fbda1.cooks_brook_eastham.jpg"
                                                },
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "cooks_brook_eastham.jpg"
                                                },
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "2c61d16b-4fac-43c6-8bcd-7711411fbda1.cooks_brook_eastham.jpg"
                                                }
                                            }
                                        },
                                        "boat_ramp": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "saltwater": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "closing_time": {
                                            "type": "string",
                                            "default": "5"
                                        },
                                        "ORV": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "parking_spaces_total": {
                                            "type": "number",
                                            "default": 100
                                        },
                                        "bathrooms": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "town_sign": {
                                            "type": "object",
                                            "properties": {
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "Entering_Eastham.png"
                                                },
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "a1da0b0c-e623-421f-a1d9-be0ed76cbba4.Entering_Eastham.png"
                                                },
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/a1da0b0c-e623-421f-a1d9-be0ed76cbba4.Entering_Eastham.png"
                                                }
                                            }
                                        },
                                        "town": {
                                            "type": "string",
                                            "default": "Eastham"
                                        },
                                        "station": {
                                            "type": "string",
                                            "default": "8446613"
                                        },
                                        "showers": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "food": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "picnic": {
                                            "type": "string",
                                            "default": "NO"
                                        },
                                        "parking_spaces_available": {
                                            "type": "number",
                                            "default": 90
                                        },
                                        "name": {
                                            "type": "string",
                                            "default": "Cooks Brook"
                                        },
                                        "beach_attended": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "handicap_access": {
                                            "type": "string",
                                            "default": "YES"
                                        },
                                        "beach_image2": {
                                            "type": "object",
                                            "properties": {
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "58624d84-706f-49d0-bbae-59cb9ef5a004.cooks_brook2_eastham.jpg"
                                                },
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/58624d84-706f-49d0-bbae-59cb9ef5a004.cooks_brook2_eastham.jpg"
                                                },
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "cooks_brook2_eastham.jpg"
                                                }
                                            }
                                        },
                                        "longitude": {
                                            "type": "string",
                                            "default": "-70.0078"
                                        },
                                        "Handicap_Parking_Spaces_Available": {
                                            "type": "number",
                                            "default": 1
                                        },
                                        "percent_full_handicap": {
                                            "type": "number",
                                            "default": 0
                                        },
                                        "pond_pdf": {
                                            "type": "object",
                                            "properties": {
                                                "fileName": {
                                                    "type": "string",
                                                    "default": "31e22cdb-3e6c-4a8f-b25d-9d0dd8aecbd0.wellfleet_long_pond.pdf"
                                                },
                                                "fileurl": {
                                                    "type": "string",
                                                    "default": "https://api.appery.io/rest/1.1/db/files/5fa4472c2e22d77647775243/31e22cdb-3e6c-4a8f-b25d-9d0dd8aecbd0.wellfleet_long_pond.pdf"
                                                },
                                                "originalFileName": {
                                                    "type": "string",
                                                    "default": "wellfleet_long_pond.pdf"
                                                }
                                            }
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "TEST_NOAA_TIDES_clone1": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/proxy/tunnel"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "datum": {
                                "type": "string",
                                "default": "MLLW"
                            },
                            "format": {
                                "type": "string",
                                "default": "json"
                            },
                            "begin_date": {
                                "type": "string",
                                "default": "20240701"
                            },
                            "end_date": {
                                "type": "string",
                                "default": "20240704"
                            },
                            "station": {
                                "type": "string",
                                "default": "8447525"
                            },
                            "time_zone": {
                                "type": "string",
                                "default": "lst_ldt"
                            },
                            "units": {
                                "type": "string",
                                "default": "english"
                            },
                            "product": {
                                "type": "string",
                                "default": "predictions"
                            },
                            "interval": {
                                "type": "string",
                                "default": "hilo"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "appery-transformation": {
                                "type": "string",
                                "default": "checkTunnel"
                            },
                            "appery-rest": {
                                "type": "string",
                                "default": "4fdbbfb0-3579-49fb-87ac-165b669e7be1"
                            },
                            "appery-proxy-url": {
                                "type": "string",
                                "default": "https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "predictions": {
                                        "type": "array",
                                        "items": [{
                                            "type": "object",
                                            "properties": {
                                                "type": {
                                                    "type": "string",
                                                    "default": "H"
                                                },
                                                "t": {
                                                    "type": "string",
                                                    "default": "2023-06-28 19:48"
                                                },
                                                "v": {
                                                    "type": "string",
                                                    "default": "9.505"
                                                }
                                            }
                                        }]
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "get_beach_list_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/code/d1168916-a0e0-4e20-a303-bd17f45a35f5/exec"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "town": {
                                "type": "string",
                                "default": "Eastham"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "name": {
                                            "type": "string",
                                            "default": "Kingsbury"
                                        },
                                        "_id": {
                                            "type": "string",
                                            "default": "66718d4d66003017cd31df9b"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "RewriteService": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "text": {
                                "type": "string"
                            },
                            "model": {
                                "type": "string"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "ChatGPTService": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "prompt": {
                                "type": "string"
                            },
                            "model": {
                                "type": "string",
                                "default": "gpt-4o"
                            },
                            "format": {
                                "type": "any"
                            },
                            "image": {
                                "type": "any"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "any"
                    }
                }
            }
        }
    },
    "GenerateImageService": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "model": {
                                "type": "string",
                                "default": "dall-e-3"
                            },
                            "prompt": {
                                "type": "string"
                            },
                            "size": {
                                "type": "string",
                                "default": "1024x1024"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "url": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "TranslateService": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "to": {
                                "type": "string"
                            },
                            "model": {
                                "type": "string"
                            },
                            "from": {
                                "type": "string"
                            },
                            "text": {
                                "type": "string"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    }
};
/**
 * Data storage
 */
export const _aioDefStorageValues = {
    variables: {
        "town": 'Eastham',
        "name": 'Cooks Brook'
    },
    storages: {
    },
    functions: {
    }
}